
import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, Link } from 'react-router-dom';
import HomePage from './pages/HomePage';
import PracticePage from './pages/PracticePage';
import QuizPage from './pages/QuizPage';
import { AppBar, Toolbar, Button, Container, Box, Dialog, DialogTitle, DialogContent, DialogActions, Slider, Typography } from '@mui/material';
import { FontSizeProvider } from './context/FontSizeContext';

const App: React.FC = () => {
  const [penThickness, setPenThickness] = useState(() => {
    const savedThickness = localStorage.getItem('penThickness');
    return savedThickness ? Number(savedThickness) : 5;
  });
  
  const [hanjaDisplaySize, setHanjaDisplaySize] = useState(() => {
    const savedSize = localStorage.getItem('hanjaDisplaySize');
    return savedSize ? Number(savedSize) : 300; // Default size
  });

  const [openOptionsDialog, setOpenOptionsDialog] = useState(false);

  const handleOpenOptionsDialog = () => {
    setOpenOptionsDialog(true);
  };

  const handleCloseOptionsDialog = () => {
    setOpenOptionsDialog(false);
  };

  useEffect(() => {
    localStorage.setItem('penThickness', penThickness.toString());
  }, [penThickness]);

  useEffect(() => {
    localStorage.setItem('hanjaDisplaySize', hanjaDisplaySize.toString());
  }, [hanjaDisplaySize]);

  return (
    <Router>
      <FontSizeProvider>
        <AppBar position="static">
          <Toolbar sx={{ justifyContent: 'center' }}>
            <Button color="inherit" component={Link} to="/">
              홈
            </Button>
            <Button color="inherit" component={Link} to="/practice">
              순서대로 연습
            </Button>
            <Button color="inherit" component={Link} to="/random-practice">
              랜덤으로 연습
            </Button>
            <Button color="inherit" component={Link} to="/quiz">
              한자 퀴즈
            </Button>
            <Button color="inherit" onClick={handleOpenOptionsDialog}>
              옵션
            </Button>
          </Toolbar>
        </AppBar>
        <Container>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            minHeight="100vh"
            textAlign="center"
            pt={4}
          >
            <Routes>
              <Route 
                path="/practice" 
                element={
                  <PracticePage 
                    isRandom={false} 
                    penThickness={penThickness} 
                    hanjaDisplaySize={hanjaDisplaySize} 
                  />
                }
              />
              <Route 
                path="/random-practice" 
                element={
                  <PracticePage 
                    isRandom={true} 
                    penThickness={penThickness} 
                    hanjaDisplaySize={hanjaDisplaySize} 
                  />
                }
              />
              <Route path="/quiz" element={<QuizPage hanjaDisplaySize={hanjaDisplaySize} />} />
              <Route path="/" element={<HomePage />} />
            </Routes>
          </Box>
        </Container>

        <Dialog open={openOptionsDialog} onClose={handleCloseOptionsDialog}>
          <DialogTitle>그리기 옵션</DialogTitle>
          <DialogContent>
            <Box sx={{ width: 250, mt: 2 }}>
              <Typography gutterBottom>펜 두께:</Typography>
              <Slider
                value={penThickness}
                onChange={(e, newValue) => setPenThickness(newValue as number)}
                min={1}
                max={20}
                valueLabelDisplay="auto"
              />
            </Box>
            <Box sx={{ width: 250, mt: 2 }}>
              <Typography gutterBottom>한자 크기:</Typography>
              <Slider
                value={hanjaDisplaySize}
                onChange={(e, newValue) => setHanjaDisplaySize(newValue as number)}
                min={100}
                max={500}
                valueLabelDisplay="auto"
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseOptionsDialog}>닫기</Button>
          </DialogActions>
        </Dialog>
      </FontSizeProvider>
    </Router>
  );
};

export default App;
